
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.384 4.617l-.739.738M22.442 12h-1.044M2.602 12H1.558M5.355 5.355l-.739-.738M12 2.602V1.558","stroke":"currentColor","stroke-width":"1.7","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M14.636 16.594H9.33","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M8.922 15.999c-1.89-1.294-2.698-3.627-1.998-5.766.7-2.139 2.747-3.592 5.06-3.591 2.313 0 4.36 1.454 5.058 3.594.699 2.14-.111 4.471-2.002 5.764a.878.878 0 00-.404.717v2.375c0 .57-.233 1.115-.648 1.518a2.247 2.247 0 01-1.563.628h-.885c-.587 0-1.15-.226-1.564-.628a2.114 2.114 0 01-.648-1.518v-2.371a.884.884 0 00-.406-.722z","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    